import { Common, ApiBind } from './common.model';

export class DeliverySetTesterCustom extends Common {
  @ApiBind({ column: 'text_target' })
  textTarget: string;
}
